module.exports = __webpack_public_path__ + "img/gestao_municipal_ouro.c8c8eae7.png";